export function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}


// WEBPACK FOOTER //
// ./~/tiny-slider/src/helpers/hasAttr.js